<template>
  <div class="columns is-multiline">
    <div class="column no-padding-mobile">
      <request-chat @deleteMessage="emitDeleteMessage" @newMessage="emitNewMessage" :entries="events" :rol="rol">
        <div class="current-status level is-mobile">
          <div class="level-left">
            <div class="level-item">
              <b>{{ $t('Estado') }}:</b>{{ $t(requestData.status) }}
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <b-select :placeholder="$t('Cambiar de fase')" @input="emitUpdateRequestStatus">
                <option v-for="option in possibleStates" :value="option" :key="option">
                  {{ $t(option) }}
                </option>
              </b-select>
            </div>
          </div>
        </div>
      </request-chat>
    </div>
  </div>
</template>

<script>
import RequestChat from '@/components/on-board/RequestChat'

export default {
  name: 'RequestTimeline',
  data() {
    return {
      possibleStates: ['P2-S', 'P3-S']
    }
  },
  props: {
    events: {
      type: Array,
      required: true
    },
    requestData: {
      type: Object,
      required: true
    },
    rol: {
      type: String,
      default: 'ecobanka'
    }
  },
  components: { RequestChat },
  computed: {
    
  },
  methods: {
    emitNewMessage: function(content) {
      this.$emit('newMessage', content)
    },
    emitDeleteMessage: function(message) {
      this.$emit('deleteMessage', message)
    },
    emitUpdateRequestStatus: function(newState) {
      this.$emit('updateRequestStatus', {
        status: newState,
        manualUpdate: true
      })
    }
  }
}
</script>

<style lang="scss">
.timeline .column {
  height: 100%;
}

.framed {
  position: relative;
  height: 100%;
  border: solid 2px #de4281;
  border-radius: 10px;
  overflow: hidden;
  padding: 20px;
  box-shadow: 0 0 15px #dddddd;
  background: white;

  > div {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }

  //TODO Estudiar alturas para encaixar perfecto
  /* altura de chat-component segun "RequestChat.vue -> .current-status" */
  .chat-component {
    height: calc(100% - 113px);
    overflow-y: scroll;
  }
  .chat-input {
    background: #de4281;
    padding: 10px 5px;

    .field {
      margin-bottom: 0;
    }
  }
}

.columns.is-multiline {
  height: calc(100vh - 150px);

  .column {
    height: 100%;
  }
}
</style>
